import { AttachedOffline, ChangeOffline } from '../model/storedData';

import { Area } from '../model/area';
import { AreaService } from './areaService';
import { AttachmentAirService } from './attachmentAir.service';
import { AttachmentType } from '../model/attachment';
import { CompressedGas } from '../model/compressedGasesAir';
import { CompressedGasService } from './compressedGasService';
import { DexieService } from './dexieService';
import { EquipmentAir } from '../model/equipment';
import { EssayAirService } from './essayAir.service';
import { EssayProtocolAir } from '../model/essayProtocolAir';
import { ExecutionAirService } from './executionAir.service';
import { ExecutionEquipmentService } from './executionEquipmentService';
import { FileUtils } from '../utils/fileUtils';
import { FilterAir } from '../model/filterAir';
import { FilterService } from './filterService';
import { Injectable } from '@angular/core';
import { RoomAir } from '../model/roomAir';
import { RoomService } from './roomService';
import { Volume } from '../model/volume';
import { VolumeService } from './volumeService';
import { DateUtils } from '../utils/dateUtils';
import { firstValueFrom } from 'rxjs';
import { Constants } from '../utils/constants';

@Injectable()
export class SaveExecutionOfflineService {

  constructor(
    private areaService: AreaService,
    private attachmentAirService: AttachmentAirService,
    private compressedGasService: CompressedGasService,
    private dexieService: DexieService,
    private essayAirService: EssayAirService,
    private executionEquipmentService: ExecutionEquipmentService,
    private filterService: FilterService,
    private roomService: RoomService,
    private volumeService: VolumeService,
    private executionService: ExecutionAirService) {
  }

  async saveOfflineChanges(): Promise<void> {
    const changes = await this.dexieService.changes.filter(e => !e.deleted).toArray();
    const attachments = await this.dexieService.attached.filter(x => x.type === 'file' && !x.deleted).toArray();

    const backupChanges = [...changes];
    const backupAttachments = [...attachments];

    try {
      

      for (const change of changes) {
        const { timestamp: timeStamp, execution_id: executionId } = change;
        if (!executionId || change.deleted) continue;
        try {
          switch (change.type) {
            case 'execution':
              await firstValueFrom(this.executionService.update(change.changes));
              break;

            case 'area': {
              const area = change.changes as Area;
              if (area.id != null) {
                await firstValueFrom(this.areaService.update(area, timeStamp));
              } else {
                await firstValueFrom(this.areaService.save(area, timeStamp));
              }
              break;
            }
            case 'areaDelete':
              await firstValueFrom(this.areaService.delete(change.changes as Area, timeStamp));
              break;

            case 'room': {
              const room = change.changes as RoomAir;
              if (room.id != null) {
                await firstValueFrom(this.roomService.update(room, timeStamp, executionId));
              } else {
                await firstValueFrom(this.roomService.save(room, timeStamp, executionId));
              }
              break;
            }
            case 'roomDelete':
              await firstValueFrom(this.roomService.delete(change.changes as RoomAir, timeStamp, executionId));
              break;

            case 'gas': {
              const gas = change.changes as CompressedGas;
              if (gas.id != null) {
                await firstValueFrom(this.compressedGasService.update(gas, timeStamp, executionId));
              } else {
                await firstValueFrom(this.compressedGasService.save(gas, timeStamp, executionId));
              }
              break;
            }
            case 'gasDelete':
              await firstValueFrom(this.compressedGasService.delete(change.changes as CompressedGas, timeStamp, executionId));
              break;

            case 'filterRoom':
            case 'filterEq': {
              const filter = change.changes as FilterAir;
              if (filter.id != null) {
                await firstValueFrom(this.filterService.update(filter, timeStamp, executionId));
              } else {
                await firstValueFrom(this.filterService.save(filter, timeStamp, executionId));
              }
              break;
            }
            case 'filterRoomDelete':
            case 'filterEqDelete':
              await firstValueFrom(this.filterService.delete(change.changes as FilterAir, timeStamp, executionId));
              break;

            case 'equipment': {
              const eq = change.changes as EquipmentAir;
              if (eq.id != null) {
                await firstValueFrom(this.executionEquipmentService.update(eq, timeStamp, executionId));
              } else {
                await firstValueFrom(this.executionEquipmentService.save(eq, timeStamp, executionId));
              }
              break;
            }
            case 'equipmentDelete':
              await firstValueFrom(this.executionEquipmentService.delete(change.changes as EquipmentAir, timeStamp, executionId));
              break;

            case 'essayRoom':
            case 'essayGas':
            case 'essayEquipment': {
              const essay = change.changes as EssayProtocolAir;
              if (essay.id != null) {
                await firstValueFrom(this.essayAirService.update(essay, timeStamp, executionId));
              } else {
                await firstValueFrom(this.essayAirService.save(essay, timeStamp, executionId));
              }
              break;
            }
            /*case 'essayRoomDelete':
            case 'essayGasDelete':
            case 'essayEquipmentDelete':
              await firstValueFrom(this.essayAirService.delete(change.changes as EssayProtocolAir, timeStamp, executionId));
              break;*/

            case 'volumeRoom': {
              const volume = change.changes as Volume;
              if (volume.id != null) {
                await firstValueFrom(this.volumeService.update(volume, timeStamp, executionId));
              } else {
                await firstValueFrom(this.volumeService.save(volume, timeStamp, executionId));
              }
              break;
            }
            case 'volumeDelete':
              await firstValueFrom(this.volumeService.delete(change.changes as Volume, timeStamp, executionId));
              break;
          }

          change.deleted = true;
          change.dateDeleted = DateUtils.getTimestampOffline();
          void this.dexieService.changes.update(change.id, change);
        } catch (syncError) {
          console.error(`Error sincronizando ${change.type}:`, syncError);
        }
      }

      for (const att of attachments) {
        try {
          const blob = FileUtils.toFile(att.blob, att.fileName);
          await firstValueFrom(this.attachmentAirService.uploadAttachmentToExecution(att.idExecution, blob, AttachmentType.OTHERS));

          att.deleted = true;
          att.dateDeleted = DateUtils.getTimestampOffline();
          await this.dexieService.attached.delete(att.id);
        } catch (fileErr) {
          console.error('Error subiendo adjunto:', fileErr);
        }
      }

      console.info('Cambios offline sincronizados correctamente.');

    } catch (error) {
      console.error('Error procesando cambios offline global:', error);

      await this.dexieService.transaction('rw', this.dexieService.changes, this.dexieService.attached, async () => {
        for (const change of backupChanges) {
          await this.dexieService.changes.put(change);
        }
        for (const att of backupAttachments) {
          await this.dexieService.attached.put(att);
        }
      });

      throw error;
    }
  }

  deleteCacheDixie(): void {
    void this.dexieService.changes.toArray().then((changes: ChangeOffline[]) => {
      changes.forEach(change => {
        const timeStamp = change.dateDeleted;

        const timeStampDate = DateUtils.strTimeToDate(timeStamp);
        const now = new Date();
        timeStampDate.setDate(timeStampDate.getDate() + 7);
        if (now.getTime() > timeStampDate.getTime()) {
          void this.dexieService.changes.delete(change.id).then(() => { });
          return;
        }
      });
    });

    void this.dexieService.attached.toArray().then((changes: AttachedOffline[]) => {
      changes.forEach(change => {
        const timeStamp = change.dateDeleted ? change.dateDeleted : change.timestamp;
        const timeStampDate = DateUtils.strTimeToDate(timeStamp);
        const now = new Date();
        timeStampDate.setDate(timeStampDate.getDate() + 7);
        if (now.getTime() > timeStampDate.getTime()) {
          void this.dexieService.attached.delete(change.id).then(() => { });
          return;
        }
      });
    });
  }
}
